module.exports = __webpack_public_path__ + "static/media/credit_card.bb9aa68c.svg";